/*
 * Copyright 2024 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import axios from "axios";

const BASE_URL = "/api/v1/data-manager";

/** Unit of workspace info payload. This type contain
 * all relevant details, and be used everywhere. */
export type WorkspaceData = {
    workspaceId: string;
    workspaceName: string;
    workspaceSrn: string;
};

export interface GetWorkspacesResponse {
    workspaces: WorkspaceData[];
}

export const getWorkspaces = async (): Promise<WorkspaceData[]> => {
    const url = BASE_URL + "/workspaces";

    const response = await axios.get<GetWorkspacesResponse>(url);

    return response.data?.workspaces || [];
};
